import {
  imgproxySettings,
  mobileImgproxySettings,
  resolvePaceOptionsFromSKU as resolveOptionsFromSKU,
  stripMatteOrInfinitePrefix,
} from './shared.mjs'

export const frame = {
  id: 'frame',
  name: 'Frame',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    Fneonblue: {
      pathTemplate: 'gs://sg360/260416/velans2/v2f_Faruroablue_{nnn}.png',
    },
    Fneonyellow: {
      pathTemplate: 'gs://sg360/260416/velans2/v2f_Faruroayellow_{nnn}.png',
    },
    Fglacierblue: {
      pathTemplate: 'gs://sg360/260416/velans2/v2f_Fglacialblue_{nnn}.png',
    },
    Fblack: {
      pathTemplate: 'gs://sg360/260416/velans2/v2f_Fphantomblack_{nnn}.png',
    },
    white: {
      pathTemplate: 'gs://sg360/260416/velans2/frameUpdate/v2f_Mwhite_{nnn}.png',
    },
    black: {
      pathTemplate: 'gs://sg360/260416/velans2/frameUpdate/v2f_Mblack_{nnn}.png',
    },
  },
}

export const lenses = {
  id: 'lens',
  name: 'Lenses',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    clear: {
      pathTemplate: 'gs://sg360/260416/velans2/v2le_8clear_{nnn}.png',
    },
    gold: {
      pathTemplate: 'gs://sg360/260416/velans2/v2le_8gold_{nnn}.png',
    },
    green: {
      pathTemplate: 'gs://sg360/260416/velans2/v2le_8green_{nnn}.png',
    },
    fire: {
      pathTemplate: 'gs://sg360/260416/velans2/v2le_8fire_{nnn}.png',
    },
    silverblue: {
      pathTemplate: 'gs://sg360/260416/velans2/v2le_8silverblue_{nnn}.png',
    },
    smoke: {
      pathTemplate: 'gs://sg360/260416/velans2/v2le_8smoke_{nnn}.png',
    },
    plum: {
      pathTemplate: 'gs://sg360/260903/ve2le_8plum--{nnn}.png',
    },
    IRsmoke: {
      pathTemplate: 'gs://sg360/260416/velans2/v2le_8IRISsmoke_{nnn}.png',
    },
    IRhvblue: {
      pathTemplate: 'gs://sg360/260416/velans2/v2le_8IRIShvblue_{nnn}.png',
    },
    IRgold: {
      pathTemplate: 'gs://sg360/260903/ve2le_8IRgold--{nnn}.png',
    },
    chrome4: {
      pathTemplate: 'gs://sg360/260416/velans2/v2le_8chrome_{nnn}.png',
    },
  },
}

export const iris = {
  id: 'iris',
  name: 'Iris Mask',
  imgproxySettings,
  mobileImgproxySettings,
  isIrisMask: true,
  options: {
    none: {
      disabled: true,
    },
    IRsmoke: {
      pathTemplate: 'gs://sg360/260416/velans2/v2le_8IRISsmoke_{nnn}_overlay.png',
      maxOpacity: 1,
    },
    IRhvblue: {
      pathTemplate: 'gs://sg360/260416/velans2/v2le_8IRIShvblue_{nnn}_overlay.png',
      maxOpacity: 1,
    },
    IRgold: {
      pathTemplate: 'gs://sg360/260903/ve2le_8IRgold--{nnn}-overlay.png',
      maxOpacity: 1,
    },
  },
}

export const icons = {
  id: 'icons',
  name: 'Icons',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    Bblack: {
      pathTemplate: 'gs://sg360/260416/velans2/v2i_Bblack_{nnn}.png',
    },
    Bblue: {
      pathTemplate: 'gs://sg360/260416/velans2/v2i_Bblue_{nnn}.png',
    },
    Bgold: {
      pathTemplate: 'gs://sg360/260416/velans2/v2i_Bgold_{nnn}.png',
    },
    Bgunmetal: {
      pathTemplate: 'gs://sg360/260416/velans2/v2i_Bgunmetal_{nnn}.png',
    },
    Bsilver: {
      pathTemplate: 'gs://sg360/260416/velans2/v2i_Bsilver_{nnn}.png',
    },
    Brosegold: {
      pathTemplate: 'gs://sg360/260416/velans2/v2i_Brosegold_{nnn}.png',
    },
    Bwhite: {
      pathTemplate: 'gs://sg360/260416/velans2/v2i_Bwhite_{nnn}.png',
    },
    Bneonyellow: {
      pathTemplate: 'gs://sg360/260416/velans2/v2i_Baurorayellow_{nnn}.png',
    },
  },
}

export const reflection = {
  id: 'reflections',
  name: 'Reflections',
  isReflection: true,
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    none: {
      disabled: true,
    },
  },
}

export const background = {
  id: 'background',
  name: 'Background',
  imgproxySettings: ['insecure', 'resize:fill:1400', 'plain'],
  mobileImgproxySettings: ['insecure', 'resize:fill:800', 'plain'],
  isBackground: true,
  options: {
    default: {
      pathTemplate: 'gs://sg360/260416/velans2/shadow/V2_shadow-{nnn}.png',
    },
  },
}

function resolveOptions(customisedProduct) {
  const getSKUWithoutPrefix = (sku) => sku?.split('_')?.slice(1)?.join('_')

  return {
    frame: stripMatteOrInfinitePrefix(getSKUWithoutPrefix(customisedProduct.frameChoice?.sku)),
    icons: customisedProduct.iconChoice?.sku?.split('_')?.slice(1)?.join('_'),
    iris: getSKUWithoutPrefix(customisedProduct.lensChoice.skuWithoutLensTech),
    lens: getSKUWithoutPrefix(customisedProduct.lensChoice.skuWithoutLensTech),
    reflections: 'none',
  }
}

export default {
  supports360: false,
  layers: [background, frame, icons, lenses, iris, reflection],
  resolveOptions,
  resolveOptionsFromSKU,
}
